import { CheckmarkFilledIcon } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { ComponentPropsWithoutRef, FC } from 'react'

interface Props extends ComponentPropsWithoutRef<'button'> {
  checked: boolean
}

export const Checkbox: FC<Props> = ({ checked, ...restProps }) => {
  return (
    <StyledButton checked={checked} {...restProps}>
      {checked && <CheckmarkFilledIcon className={'w-6'} style={{ color: 'white' }} />}
    </StyledButton>
  )
}

const StyledButton = styled.button<{ checked: boolean }>`
  visibility: visible;
  position: relative;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  width: 1.5rem;
  min-width: 1.5rem;
  cursor: pointer;
  border-radius: 0.25rem;
  border-width: 2px;
  border-style: solid;
  background: ${({ checked }) => (checked ? '#000000' : '#FFFFFF')};
  border-color: ${({ checked }) => (checked ? 'transparent' : '#E7E6E4')};
`
